import { Component, Input, OnInit } from '@angular/core';
import { ChatMessage, UserService } from '@uzurv/clara';
import { AuthDataService } from '@uzurv/http';

@Component({
  selector: 'app-chat-message-list-item',
  templateUrl: './chat-message-list-item.component.html',
  styleUrls: ['./chat-message-list-item.component.scss']
})
export class ChatMessageListItemComponent implements OnInit {
  @Input()
  chatMessage: ChatMessage;

  constructor(public userService: UserService, public authDataService: AuthDataService) {}

  ngOnInit() {}

  isCurrentUserSender(): boolean {
    return this.authDataService.currentUser.claraPersonId === this.chatMessage.senderPersonId;
  }
}
